/* eslint-disable camelcase */
/* eslint-disable complexity */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import withMemo from '../../decorators/withMemo';
import { app } from '../../configuration';
import { colors } from '../../theme';
import JsonLd from '../JsonLd';
import { declaration as fontDeclarations } from '../../theme/fonts';
var Metadatas = function Metadatas(props) {
  var applicationName = props.applicationName,
    seo = props.seo,
    base = props.base,
    jsonld = props.jsonld,
    alternates = props.alternates;
  var preloadFonts = useMemo(function () {
    return Object.values(fontDeclarations).map(function (f, k) {
      var _f$formats$0$ext, _f$formats, _f$formats$;
      var ext = (_f$formats$0$ext = (_f$formats = f.formats) == null ? void 0 : (_f$formats$ = _f$formats[0]) == null ? void 0 : _f$formats$.ext) !== null && _f$formats$0$ext !== void 0 ? _f$formats$0$ext : 'ttf';
      return /*#__PURE__*/React.createElement("link", {
        rel: "preload",
        href: "/fonts/".concat(f.fontDir, "/").concat(f.fileBase, ".").concat(ext),
        as: "font",
        type: ext === 'woff2' ? 'font/woff2' : ext === 'woff' ? 'font/woff' : 'font/ttf',
        key: "".concat(f.fontFamily, "-").concat(k),
        crossOrigin: "anonymous"
      });
    });
  }, []);
  return /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("meta", {
    charSet: "utf-8"
  }), (seo == null ? void 0 : seo.title) && /*#__PURE__*/React.createElement("title", null, seo.title), (seo == null ? void 0 : seo.title) && /*#__PURE__*/React.createElement("meta", {
    property: "og:title",
    content: seo.title
  }), (seo == null ? void 0 : seo.description) && /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: seo.description
  }), (seo == null ? void 0 : seo.description) && /*#__PURE__*/React.createElement("meta", {
    property: "og:description",
    content: seo.description
  }), (seo == null ? void 0 : seo.type) && /*#__PURE__*/React.createElement("meta", {
    property: "og:type",
    content: seo.type
  }), (seo == null ? void 0 : seo.url) && /*#__PURE__*/React.createElement("meta", {
    property: "og:url",
    content: seo.url
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:locale",
    content: "fr_FR"
  }), (seo == null ? void 0 : seo.title) && /*#__PURE__*/React.createElement("meta", {
    name: "twitter:title",
    content: seo.title
  }), (seo == null ? void 0 : seo.description) && /*#__PURE__*/React.createElement("meta", {
    name: "twitter:description",
    content: seo.description
  }), (seo == null ? void 0 : seo.twitter_card) && /*#__PURE__*/React.createElement("meta", {
    name: "twitter:card",
    content: seo.twitter_card
  }), (seo == null ? void 0 : seo.image) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("meta", {
    property: "og:image",
    content: seo.image
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:image",
    content: seo.image
  })), (seo == null ? void 0 : seo.twitter_account) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("meta", {
    property: "twitter:site",
    content: seo.twitter_account
  }), /*#__PURE__*/React.createElement("meta", {
    name: "twitter:creator",
    content: seo.twitter_account
  })), (seo == null ? void 0 : seo.url) && /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: seo.url
  }), seo != null && seo.noindex || app.NO_INDEX ? /*#__PURE__*/React.createElement("meta", {
    name: "robots",
    content: "noindex, nofollow"
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("meta", {
    name: "robots",
    content: "index, follow"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "googlebot",
    content: "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
  })), /*#__PURE__*/React.createElement("base", {
    href: base
  }), /*#__PURE__*/React.createElement("meta", {
    name: "screen-orientation",
    content: "portrait"
  }), /*#__PURE__*/React.createElement("meta", {
    content: "width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=5",
    name: "viewport"
  }), jsonld && /*#__PURE__*/React.createElement(JsonLd, {
    data: jsonld
  }), /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: "https://res.cloudinary.com",
    crossOrigin: "anonymous"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "preconnect",
    href: "https://sessions.bugsnag.com",
    crossOrigin: "anonymous"
  }), preloadFonts, /*#__PURE__*/React.createElement("link", {
    rel: "apple-touch-icon",
    sizes: "180x180",
    href: "/apple-touch-icon.png"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "32x32",
    href: "/favicon-32x32.png"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "icon",
    type: "image/png",
    sizes: "16x16",
    href: "/favicon-16x16.png"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "manifest",
    href: "/site.webmanifest"
  }), /*#__PURE__*/React.createElement("link", {
    rel: "mask-icon",
    href: "/safari-pinned-tab.svg",
    color: colors.seaBlue
  }), /*#__PURE__*/React.createElement("meta", {
    name: "apple-mobile-web-app-title",
    content: "Nice Port Center"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "application-name",
    content: "Nice Port Center"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "msapplication-TileColor",
    content: colors.seaBlue
  }), /*#__PURE__*/React.createElement("meta", {
    name: "theme-color",
    content: "#ffffff"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "theme-color",
    content: colors.seaBlue
  }), /*#__PURE__*/React.createElement("meta", {
    name: "mobile-web-app-capable",
    content: "yes"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "apple-mobile-web-app-title",
    content: applicationName
  }), /*#__PURE__*/React.createElement("meta", {
    name: "apple-mobile-web-app-capable",
    content: "yes"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "apple-mobile-web-app-status-bar-style",
    content: "default"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "msapplication-config",
    content: "browserconfig.xml"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "application-name",
    content: applicationName
  }), /*#__PURE__*/React.createElement("meta", {
    name: "msapplication-tooltip",
    content: applicationName
  }), /*#__PURE__*/React.createElement("meta", {
    name: "msapplication-starturl",
    content: "/fr"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "msapplication-tap-highlight",
    content: "no"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "full-screen",
    content: "yes"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "browsermode",
    content: "application"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "nightmode",
    content: "enable"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "layoutmode",
    content: "fitscreen"
  }), /*#__PURE__*/React.createElement("meta", {
    name: "imagemode",
    content: "force"
  }), alternates && alternates.map(function (alternate) {
    return /*#__PURE__*/React.createElement("link", {
      rel: "alternate",
      href: alternate.url,
      hrefLang: alternate.iso,
      key: "alternates-".concat(alternate.iso)
    });
  }));
};
Metadatas.propTypes = {
  applicationName: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  seo: PropTypes.object,
  base: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  jsonld: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  alternates: PropTypes.array
};
Metadatas.defaultProps = {
  applicationName: null,
  seo: null,
  base: null,
  jsonld: null,
  alternates: null
};
export default withMemo()(Metadatas);